import React from 'react';
import { Form, Spin } from '@douyinfe/semi-ui';
import { isEmpty, isNull } from "lodash";

//import controller;
import { initMailSystem, checkMailSystem } from "../../../controllers/initController";

class InitMailSystem extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            message: null
        };
        this.handleCreateMails = this.handleCreateMails.bind(this);
    }

    handleCreateMails = async() => {
        const toaster = this.props.toaster;

        try{
            let check = await checkMailSystem();
            if (!isEmpty(check) && !isNull(check) && check.success === true) {
                this.setState({ message: "Инициализация почтовой системы завершена.", done: true });
                this.props.check(false);
                return;
            } else {
                let request = await initMailSystem();
                if (!isEmpty(request) && !isNull(request)) {
                    toaster.success({ content: request.message });
                    this.setState({ message: request.message, done: true });
                    this.props.check(false);
                    return;
                }
            }
        }catch(e){
            toaster.error({ content: e.response?.data?.message || 'Ошибка инициализации' });
        }
    }

    componentDidMount() {
        this.props.check(true);
        this.handleCreateMails();
    }

    render() {

        let done = this.state.done;

        return (
            <Form layout="vertical">
                <div className='modal-fixed-custom' style={{ textAlign: 'center' }}>
                    {done ? (
                        <div>
                            <span style={{ color: 'green', fontSize: 48, paddingBottom: 15 }}>✓</span>
                            <span>{this.state.message}</span>
                        </div>
                    ) : (
                        <Spin size="large" style={{width: "100%", textAlign: 'center'}} tip="Инициализация почтовой системы..." />
                    )}
                </div>
            </Form>
        );
    };
}

export default InitMailSystem;